import Vue from 'vue'
import Router from 'vue-router'

import Sports from '@/components/sports/Sports'
import SportsMain from '@/components/sports/main/View'
import SportsMain2 from '@/components/sports/main_sport_2/Menu'

import HomeLive from '@/components/sports/main/live/View'
import HomePopular from '@/components/sports/main/popular/View'

import PrematchMatchList from '@/components/sports/matches/View'
import PrematchEvent from '@/components/sports/eventview/View'

import Live from '@/components/live/Live'
import LiveOverview from '@/components/live/overview/View'
import LiveEvent from '@/components/live/eventview/View'
import LiveUpcoming from '@/components/live/upcoming/View'

import Favorites from '@/components/favorites/Favorites'
import PrematchFavorites from '@/components/favorites/PrematchView'
import LiveFavorites from '@/components/favorites/LiveView'

import Results from '@/components/results/Results'
import ResultsLive from '@/components/results/ResultsLive'

import Account from '@/components/account/Account'
import AccountBets from '@/components/account/bets/View'

import RulesMenu from '@/components/rules/menu/View'
import RulesArticle from '@/components/rules/article/View'

import AccountPayments from '@/components/account/payments/View'
import AccountPaymentHistory from '@/components/account/payments/history/View'

import AccountProfile from '@/components/account/profile/View'
import AccountBonuses from '@/components/account/bonuses/View'

import Bonuses from '@/components/bonuses/View'
import Vip from '@/components/vip/View'

import Kazino from '@/components/kazino/Kazino'
import Games from '@/components/kazino/Games'
import Game from '@/components/kazino/Game'
import Gamerpl from '@/components/kazino/Gamerpl'

import Payments from '@/components/payments/Payments'

import RegisterRo from '@/components/register/RegisterRo'
import RegisterAz from '@/components/register/RegisterAz'
import RegisterAzx from '@/components/register/RegisterAzx'

// const config = require('@/config/default').default

// const AccountDeposit = () => import(`@/components/account/payments/deposit/${config.name}/View`)
// const AccountWithdrawal = () => import(`@/components/account/payments/withdrawal/${config.name}/View`)

const AccountDeposit = () => import('@/components/account/payments/deposit/dev_two/View')
const AccountWithdrawal = () => import('@/components/account/payments/withdrawal/dev_two/View')

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    component: Sports,
    meta: { page: 'main' },
    children: [{
      path: '/',
      component: SportsMain,
      meta: { view: 'main' },
      children: [{
        path: '/',
        component: HomeLive,
        meta: { section: 'live' }
      }, {
        path: '/video/:video',
        component: HomeLive,
        meta: { section: 'live' }
      }, {
        path: '/home/live/sport/:sport/video/:video',
        component: HomeLive,
        meta: { section: 'live' }
      }, {
        path: '/home/live/sport/:sport',
        component: HomeLive,
        meta: { section: 'live' }
      },
      {
        path: '/live/upcoming',
        component: LiveUpcoming,
        meta: { page: 'upcoming' }
      }, {
        path: '/live/upcoming/sport/:sport',
        component: LiveUpcoming,
        meta: { page: 'upcoming' }
      },
      {
        path: '/popular',
        component: HomePopular,
        meta: { section: 'popular' }
      }, {
        path: '/popular/sport/:sport',
        component: HomePopular,
        meta: { section: 'popular' }
      }]
    }, {
      path: '/prematch',
      component: SportsMain2,
      meta: { page: 'sports' }
    }, {
      path: '/prematch/sport/:sport',
      component: SportsMain2,
      meta: { page: 'sports' }
    }, {
      path: '/prematch/sport/:sport/country/:country',
      component: PrematchMatchList,
      meta: { page: 'sports' }
    }, {
      path: '/prematch/sport/:sport/league/:league',
      component: PrematchMatchList,
      meta: { page: 'sports' }
    }, {
      path: '/prematch/sport/:sport/event/:event',
      component: PrematchEvent,
      meta: { page: 'sports' }
    }, {
      path: '/prematch/sport/:sport/event/:event/period/:period',
      component: PrematchEvent,
      meta: { page: 'sports' }
    }]
  }, {
    path: '/live',
    component: Live,
    meta: { page: 'live' },
    children: [{
      path: '/live',
      component: LiveOverview,
      meta: { view: 'overview' }
    }, {
      path: '/live/sport/:sport',
      component: LiveOverview,
      meta: { view: 'overview' }
    }, {
      path: '/live/sport/:sport/lang/:lang',
      component: LiveOverview,
      meta: { view: 'overview' }
    }, {
      path: '/live/sport/:sport/event/:event',
      component: LiveEvent,
      meta: { view: 'eventview' }
    }, {
      path: '/live/sport/:sport/event/:event/period/:period',
      component: LiveEvent,
      meta: { view: 'eventview' }
    }]
  }, {
    path: '/favorites/live',
    component: Favorites,
    meta: { page: 'favorites' },
    children: [{
      path: '/favorites/prematch',
      component: PrematchFavorites,
      meta: { view: 'prematch' }
    }, {
      path: '/favorites/live',
      component: LiveFavorites,
      meta: { view: 'live' }
    }]
  }, {
    path: '/results/date/:date',
    component: Results,
    meta: { page: 'results' }
  }, {
    path: '/results/date/:date/sport/:sport',
    component: Results,
    meta: { page: 'results' }
  }, {
    path: '/results/date/:date/sport/:sport/league/:league',
    component: Results,
    meta: { page: 'results' }
  }, {
    path: '/resultslive',
    component: ResultsLive,
    meta: { page: 'resultslive' }
  }, {
    path: '/resultslive/league/:league',
    component: ResultsLive,
    meta: { page: 'resultslive' }
  }, {
    path: '/account/bets',
    component: Account,
    children: [{
      path: '/account/bets',
      component: AccountBets,
      meta: { view: 'bets' },
      beforeEnter: (to, from, next) => {
        if (!to.params.from || !to.params.to) {
          let dateFrom = (new Date(Date.now() + (3600000 * 3) - (3600000 * 142))).toISOString().split('T')[0]
          let date = (new Date(Date.now() + 3600000 * 3)).toISOString().split('T')[0]
          next(`/account/bets/from/${dateFrom}/to/${date}`)
        } else next()
      }
    }, {
      path: '/account/bets/from/:from/to/:to',
      component: AccountBets,
      meta: { view: 'bets' }
    }, {
      path: '/account/payments',
      component: AccountPayments,
      meta: { view: 'payments' },
      children: [{
        path: '/account/payments',
        alias: '/account/payments/deposit',
        component: AccountDeposit,
        meta: { section: 'deposit' }
      }, {
        path: '/account/payments/withdrawal',
        component: AccountWithdrawal,
        meta: { section: 'withdrawal' }
      }, {
        path: '/account/payments/history',
        component: AccountPaymentHistory,
        meta: { section: 'history' },
        beforeEnter: (to, from, next) => {
          if (!to.params.from || !to.params.to) {
            let date = (new Date(Date.now() + 3600000 * 3)).toISOString().split('T')[0]
            next(`/account/payments/history/from/${date}/to/${date}`)
          } else next()
        }
      }, {
        path: '/account/payments/history/from/:from/to/:to',
        component: AccountPaymentHistory,
        meta: { section: 'history' }
      }]
    }, {
      path: '/account/profile',
      component: AccountProfile,
      meta: { view: 'profile' }
    }, {
      path: '/account/bonuses',
      component: AccountBonuses,
      meta: { view: 'bonuses' }
    }, {
      path: '/vip',
      component: Vip,
      meta: {page: 'vip'}
    }, {
      path: '/bonuses',
      component: Bonuses,
      meta: {page: 'bonuses'}
    }, {
      path: '/payments',
      component: Payments,
      meta: { view: 'payments' }
    }, {
      path: '/rules',
      component: RulesMenu,
      meta: { page: 'rules' }
    }, {
      path: '/rules/article/:article',
      component: RulesArticle,
      meta: { page: 'rules' }
    }, {
      path: '/casino',
      component: Kazino,
      meta: { view: 'casino' }
    }, {
      path: '/games',
      component: Games,
      meta: { view: 'casino' }
    }, {
      path: '/game/id/:id',
      component: Game,
      meta: { view: 'casino' }
    }, {
      path: '/gamerpl/id/:id',
      component: Gamerpl,
      meta: { view: 'casino' }
    }, {
      path: '/registerro',
      component: RegisterRo,
      meta: { view: 'registerro' }
    }, {
      path: '/registeraz',
      component: RegisterAz,
      meta: { view: 'registeraz' }
    }, {
      path: '/registerazx',
      component: RegisterAzx,
      meta: { view: 'registerazx' }
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js